import { toNumber } from '../../utils/numbers';
import convertUnit from '../../utils/unit-converter';
import logger from '../../utils/logger';
import { ALLOWED_MIXER_STATUSES_FOR_NEXT_TICKET_BATCHING } from './batch-action-mixin';

export const savePumpWeightToTicket = (pump, batchStore) => {
  const pumpStatus = batchStore.getDeviceStatus(pump.id);
  const runningData = batchStore.running?.find(v => v.uid === pumpStatus.uid && v.currentDrop === pumpStatus.currentDrop);

  if (runningData?.mixDesign && runningData?.pumps) {
    const pumpData = runningData?.pumps[pump.id];
    if (!pumpData) {
      return;
    }
    const { material, materialDetails } = pumpData;
    const mixer = batchStore.devicesStore.getDeviceById(Number(runningData.mixerId));
    const isTemperWater = pump.meterPNo === mixer?.tWaterMeterStatusPNo;
    const mixerStatus = batchStore.getDeviceStatus(runningData.mixerId);
    const shouldUpdateTicket = !runningData.mixerId
      || !ALLOWED_MIXER_STATUSES_FOR_NEXT_TICKET_BATCHING.includes(mixerStatus.status)
      || runningData.uid !== mixerStatus.uid
      || runningData.currentDrop !== mixerStatus.currentDrop;
    const pumpUnit = batchStore.getUnitById(pump.unitId);
    const weight = batchStore.getPumpWeight(pump) - (pumpData?.initialValue || 0);
    let actualWeight = weight * (materialDetails.meterRate || 1);
    let manualWeight = actualWeight - pumpStatus.weight;

    if (pumpUnit && pumpUnit !== pumpStatus.unit) {
      manualWeight = toNumber(convertUnit(manualWeight, pumpUnit, pumpStatus.unit), 2);
      actualWeight = toNumber(convertUnit(actualWeight, pumpUnit, pumpStatus.unit), 2);
    }

    if (manualWeight && (isTemperWater || shouldUpdateTicket)) {
      runningData.mixDesign.forEach((v) => {
        if ((v.batchCode && v.batchCode === material.batchCode) || v.constituentItemId === material.itemId) {
          v.actualWeight = actualWeight;
          v.actualPerDrop = actualWeight;
          v.manualWeight = manualWeight;
          logger.log('manual feed:', material.code, manualWeight, weight, pumpStatus.weight, v.unitSymbol, pumpUnit, pumpStatus.status);
        }
      });
    }
  }
};
